/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationAppIcon20Regular = forwardRef('NotificationAppIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5.75a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5ZM13.25 4.5a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z" }),
        React.createElement("path", { d: "M3.75 6A2.25 2.25 0 0 1 6 3.75h4a.75.75 0 0 0 0-1.5H6A3.75 3.75 0 0 0 2.25 6v8A3.75 3.75 0 0 0 6 17.75h8A3.75 3.75 0 0 0 17.75 14v-4a.75.75 0 0 0-1.5 0v4A2.25 2.25 0 0 1 14 16.25H6A2.25 2.25 0 0 1 3.75 14V6Z" })));
});
